import api from '@/api';

import { PageRequest } from '@/core/request/PageRequest';

import {
  StockCorrection,
  CreateStockCorrectionRequest,
  CreateStockCorrectionResult,
  StockCorrectionDetail,
} from './StockCorrections.types';

import { API_BASE_URL } from '..';
import { PageResultStock } from '@/core/request/PageResultStock';

const CONTROLLER_URL = `${API_BASE_URL}/stock-corrections`;

export async function listStockCorrections(
  params?: PageRequest,
): Promise<PageResultStock<StockCorrection>> {
  const result = (await api.get(`${CONTROLLER_URL}`, params)) as unknown;

  return result as PageResultStock<StockCorrection>;
}

export async function getStockCorrection(
  id: number,
): Promise<StockCorrectionDetail> {
  const result = (await api.get(`${CONTROLLER_URL}/${id}`, null)) as unknown;

  return result as StockCorrectionDetail;
}

export async function createStockCorrection(
  req: CreateStockCorrectionRequest,
): Promise<CreateStockCorrectionResult> {
  const result = (await api.post(`${CONTROLLER_URL}`, req, null)) as unknown;

  return result as CreateStockCorrectionResult;
}
